import React from "react";
import "./about.css";

function About() {
  return (
    <section className="about" id="about">
      <h2>ABOUT US</h2>
      <p>
        At Muhurtmedh, we believe weddings are a timeless celebration of love.
        Our collections bring together tradition and modern elegance, making
        every bride and groom feel extraordinary.
      </p>
    </section>
  );
}

export default About;
